import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

const useForm = () => {
  const { register, getValues, setValue, watch, reset } = useFormContext();
  const onPollutantMetricFieldChange = watch("pollutant_metric");
  const onQueryLayerFieldChange = watch("query_layer");
  const onYearFieldChange = watch("year");
  const onZoneLaListFieldChange = watch("zone_la_list");

  const getSelectedQueryLayer = getValues("query_layer") ? getValues("query_layer") : "zone";
  const getSelectedPollutantMetric = getValues("pollutant_metric");
  const getSelectedYear =  getValues("year")? getValues("year"): "2021";
  const getSelectedZoneLa = getValues("zone_la_list");

  const rerenderFromWithPollutantMetrics = useCallback(
    (response) => {
      const { zoneId, laId } = response;
      reset({
        ...getValues(),
        pollutant_metric: getValues("query_layer") === "zone" ? zoneId : laId,
      });
    },
    [getValues, reset]
  );

  const resetZoneLaListField = useCallback(() => {
    setValue("zone_la_list", undefined);
  }, [setValue]);

  return {
    getSelectedQueryLayer,
    getSelectedPollutantMetric,
    getSelectedYear,
    getSelectedZoneLa,
    onPollutantMetricFieldChange,
    onQueryLayerFieldChange,
    onZoneLaListFieldChange,
    onYearFieldChange,
    setValue,
    register,
    reset,
    getValues,
    rerenderFromWithPollutantMetrics,
    resetZoneLaListField,
  };
};

export default useForm;
